import { industryPages, type IndustryPage } from './industries';
import routes from './routes.json';

/** The industry pages that are published (listed in routes.json): the only ones the site links to. A planned page is never linked. */
export const liveIndustries = (): IndustryPage[] => industryPages.filter((p) => routes.routes.includes(p.path));

/** A short name for a trade ("Junk removal"), from its slug: a page's h1 is a headline, too long for a link in a list. */
export const tradeName = (p: Pick<IndustryPage, 'slug'>): string => {
  const words = p.slug.replace(/-/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/** The published page a home trade tile links to (a tile with no page stays a plain tile). */
export const tilePage = (key: string): string | null => liveIndustries().find((p) => p.tile === key)?.path ?? null;

/** The hub's sections: one per `group` when at least two groups are named and there are more than six pages; otherwise one flat list. */
export function groupIndustries(pages: IndustryPage[]): { group: string | null; pages: IndustryPage[] }[] {
  const groups = [...new Set(pages.map((p) => p.group).filter(Boolean))] as string[];
  if (pages.length <= 6 || groups.length < 2) return [{ group: null, pages }];
  const out = groups.map((g) => ({ group: g as string | null, pages: pages.filter((p) => p.group === g) }));
  const rest = pages.filter((p) => !p.group);
  return rest.length ? [...out, { group: null, pages: rest }] : out;
}
